import { useState } from 'react'
import { Link, useNavigate, useLocation } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import { useAuth } from '../../context/AuthContext'
import { RiMailLine, RiLockLine, RiEyeLine, RiEyeOffLine, RiLoader4Line } from 'react-icons/ri'
import toast from 'react-hot-toast'

export default function Login() {
  const { login } = useAuth()
  const navigate  = useNavigate()
  const location  = useLocation()
  const from = location.state?.from || '/'

  const [showPw, setShowPw] = useState(false)

  const { register, handleSubmit, formState: { errors, isSubmitting } } = useForm()

  const onSubmit = async (data) => {
    try {
      const user = await login(data)
      toast.success(`Welcome back, ${user.name.split(' ')[0]}!`)
      navigate(user.role === 'admin' ? '/admin' : (from === '/login' ? '/dashboard' : from), { replace: true })
    } catch (err) {
      toast.error(err.response?.data?.message || 'Invalid email or password')
    }
  }

  return (
    <div>
      <div className="mb-8">
        <h1 className="font-display text-salon-dark text-3xl font-bold">Welcome back</h1>
        <p className="text-salon-muted font-body mt-2">Sign in to manage your appointments</p>
      </div>

      <form onSubmit={handleSubmit(onSubmit)} className="space-y-5">
        <div>
          <label className="input-label">Email Address</label>
          <div className="relative">
            <RiMailLine className="absolute left-3.5 top-1/2 -translate-y-1/2 text-salon-muted" />
            <input
              {...register('email', { required: 'Email is required', pattern: { value: /^\S+@\S+\.\S+$/, message: 'Invalid email' } })}
              className="input-field pl-10"
              placeholder="you@example.com"
              type="email"
              autoComplete="email"
            />
          </div>
          {errors.email && <p className="text-red-500 text-xs mt-1">{errors.email.message}</p>}
        </div>

        <div>
          <label className="input-label">Password</label>
          <div className="relative">
            <RiLockLine className="absolute left-3.5 top-1/2 -translate-y-1/2 text-salon-muted" />
            <input
              {...register('password', { required: 'Password is required' })}
              className="input-field pl-10 pr-10"
              placeholder="••••••••"
              type={showPw ? 'text' : 'password'}
              autoComplete="current-password"
            />
            <button type="button" onClick={() => setShowPw(!showPw)}
              className="absolute right-3.5 top-1/2 -translate-y-1/2 text-salon-muted hover:text-salon-dark transition-colors">
              {showPw ? <RiEyeOffLine /> : <RiEyeLine />}
            </button>
          </div>
          {errors.password && <p className="text-red-500 text-xs mt-1">{errors.password.message}</p>}
        </div>

        <div className="flex items-center justify-between">
          <label className="flex items-center gap-2 cursor-pointer">
            <input type="checkbox" className="accent-salon-primary rounded" />
            <span className="text-sm text-salon-muted font-body">Remember me</span>
          </label>
          <Link to="/forgot-password" className="text-sm text-salon-primary font-semibold font-body hover:underline">
            Forgot password?
          </Link>
        </div>

        <button type="submit" disabled={isSubmitting} className="btn-primary w-full justify-center py-3.5 text-base">
          {isSubmitting ? <><RiLoader4Line className="animate-spin" /> Signing in...</> : 'Sign In'}
        </button>
      </form>

      <p className="text-center text-sm font-body text-salon-muted mt-6">
        Don't have an account?{' '}
        <Link to="/register" className="text-salon-primary font-semibold hover:underline">Create one</Link>
      </p>
    </div>
  )
}
